// Base URLs
// const APIBASE_URL = "http://localhost:8000/";
// const MONGOAPI_BASE_URL = "http://localhost:8000/";
// const IMAGE_BASE_URL = "http://localhost:8000";
const IMAGE_BASE_URL = "https://api.epm.qcodesinfotech.com/";
const APIBASE_URL = "https://api.epm.qcodesinfotech.com/";
const MONGOAPI_BASE_URL = "https://api.epm.qcodesinfotech.com/";
// Get user type from localStorage (1=admin, 0=regular user)
const getUserType = () => {
  try {
    const userData = localStorage.getItem('token');
    return userData ? JSON.parse(userData).type : 0;
  } catch (e) {
    console.error("Error parsing userData:", e);
    return 0;
  }
};

const resolveEndpoint = (userpath, adminpath) => {
  const isAdmin = getUserType() == 1;
  if (isAdmin && adminpath) {
    return APIBASE_URL + adminpath;
  }
  return APIBASE_URL + userpath;
};

// Exported constants
export const BASE_URL = APIBASE_URL;
export const MONGO_BASE_URL = MONGOAPI_BASE_URL;
export const IMAGE_URL = IMAGE_BASE_URL;

// Authentication Endpoints
export const CLIENT_LOGIN = APIBASE_URL + 'employee/admin_login/';
export const ADMIN_LOGIN = APIBASE_URL + 'employee/admin_login/';
export const EMPLOYEE_LOGIN = APIBASE_URL + 'employee/employee_login/';
export const GENERATE_CAPTCHA = APIBASE_URL + 'employee/generate_captcha/';
export const GENERATE_CAPTCHA_ADMIN = MONGOAPI_BASE_URL + 'client/generate_captcha';
export const GET_TOKEN = APIBASE_URL + 'employee/get_token/';

// Password Management
export const ADMIN_UPDATE_PASSWORD = resolveEndpoint('employee/admin_update_password');
export const UPDATE_USER_PASSWORD = resolveEndpoint('employee/update_user_password');
export const ADMIN_SEND_PASSWORD = resolveEndpoint('employee/send_and_update_new_password');

// Forgot Password (OTP-based reset)
export const FORGOT_PASSWORD_SEND_OTP = APIBASE_URL + 'employee/forgot-password/send-otp';
export const FORGOT_PASSWORD_VERIFY_OTP = APIBASE_URL + 'employee/forgot-password/verify-otp';

// Admin: Unlock employee account
export const UNLOCK_EMPLOYEE = APIBASE_URL + 'employee/unlock/';


// Department Endpoints
export const ADD_DEPARTMENT = resolveEndpoint('depart/department/create');
export const LIST_DEPARTMENT = resolveEndpoint('depart/department/list');
export const DELETE_DEPARTMENT = resolveEndpoint('depart/department/delete');
export const UPDATEDEPARTMENT = resolveEndpoint('depart/update/');
export const SYNCDEPARTMENT = resolveEndpoint('depart/department/sync');

// Sub Department
export const LIST_SUBDEPARTMENT = resolveEndpoint('sub_depart/sub_departments');
export const DELETE_SUBDEPARTMENT = resolveEndpoint('sub_depart/delete/');
export const ADD_SUBDEPARTMENT = resolveEndpoint('sub_depart/sub_departments/create');
export const GET_SUBDEPT_BYDEPT = resolveEndpoint('sub_depart/sub_depart_list');
export const UPDATESUBDEPARTMENT = resolveEndpoint('sub_depart/update/');

// Role Access
export const LIST_ROLE = resolveEndpoint('role_access/list');
export const ADD_ROLE = resolveEndpoint('role_access/create');
export const DELETE_ROLE = resolveEndpoint('role_access/delete/');
export const UPDATEROLE = resolveEndpoint('role_access/update/');
export const SYNC_ROLE_EMPLOYEES = resolveEndpoint('role_access/sync_employees_role');

// Screenshot Interval
export const LIST_SCREEN_INTERVAL = resolveEndpoint('screenshot_interval/list');
export const ADD_SCREEN_INTERVAL = resolveEndpoint('screenshot_interval/create');
export const UPDATE_SCREEN_INTERVAL = resolveEndpoint('screenshot_interval/update/');
export const DELETE_SCREEN_INTERVAL = resolveEndpoint('screenshot_interval/delete/');

// Client
export const CLIENT_LIST = resolveEndpoint('client/list');
export const CLIENT_CREATE = resolveEndpoint('client/create');
export const CLIENT_DELETE = resolveEndpoint('client/delete');
export const CLIENT_UPDATE = resolveEndpoint('client/update');

// Organization
export const LIST_ORGANIZATION = resolveEndpoint('organization/list');

// Screenshot
export const LIST_SCREENSHOT = resolveEndpoint('screen/list');
export const LIST_SCREENSHOT_ADMIN = resolveEndpoint('screen/admin_list');
export const FILTER_SCREENSHOT = resolveEndpoint('list_filter_screen');

// Activity Tracker
export const LIST_ACTIVITY = resolveEndpoint('activity_tracker/list');
export const EMPLOG = resolveEndpoint('activity_tracker/emplog/');
export const MANUAL_TIME = resolveEndpoint('activity_tracker/manual_time/');
export const MANUAL_TIME_EDIT = resolveEndpoint('activity_tracker/manual_time/edit/');
export const MANUAL_TIME_DELETE = resolveEndpoint('activity_tracker/manual_time/delete/');
export const FILTER_EMPLOYEE = resolveEndpoint('activity_tracker/list_filter_employee');
export const LIST_EMPLOYEE_ACTIVITY = resolveEndpoint('activity_tracker/list_filter_employee');

export const DELACTIVITY = resolveEndpoint('api/del_activity');

// Whitelist
export const LIST_WHITELIST = resolveEndpoint('activity_tracker/whitelist');
export const CREATE_WHITELIST = resolveEndpoint('activity_tracker/whitelist/create');
export const DELETE_WHITELIST = resolveEndpoint('activity_tracker/whitelist/delete/');
export const UPDATE_WHITELIST = resolveEndpoint('activity_tracker/whitelist/update/');

// Reports
export const REPORT_PERSON1 = resolveEndpoint('employee/list_depart');
export const REPORT_PERSON2 = resolveEndpoint('employee/list_subdepart');
export const LIST_REPORT = resolveEndpoint('employee/list_reporting', 'employee/admin/list_reporting');
export const LIST_REPORT_BYUSER = resolveEndpoint('employee/list_reporting');
export const REPORTINGEMPLOYEE = resolveEndpoint('employee/list_employee_report');
export const EXPENDABLE_EMPLOYEE_LIST = resolveEndpoint('employee/get_employee_report');

// Employee
export const ADD_Employee = resolveEndpoint('employee/create');
export const LIST_EMPLOYEE = resolveEndpoint('employee/list');
export const ALL_LIST_EMPLOYEE = resolveEndpoint('employee/listall');
export const DELETE_EMPLOYEE = resolveEndpoint('employee/delete');
export const EDITEMPLOYEE = resolveEndpoint('employee/employee_by/');
export const UPDATEEMPLOYEE = resolveEndpoint('employee/update/');
export const UPDATEMPLOYEE = resolveEndpoint('employee/update/');
export const EMPLOYEE_SEARCH = resolveEndpoint('employee/list_search');
export const SYNCEMP = resolveEndpoint('employee/sync_emp');
export const SYNC_SCHEDULES = resolveEndpoint('employee/sync_schedules');
export const MIGRATE_EMP_IDS = resolveEndpoint('employee/migrate_emp_ids');

// Designation
export const ADD_DESIGNATION = resolveEndpoint('roles/create');
export const LIST_DESIGNATION = resolveEndpoint('roles/list');
export const DELETE_DESIGNATION = resolveEndpoint('roles/designation/delete');

// Location
export const LIST_LOCATION = resolveEndpoint('location/list');

// Project
export const LIST_PROJECT = resolveEndpoint('project/list');
export const ADD_PROJECT = resolveEndpoint('project/create');
export const CREATE_PROJECT = resolveEndpoint('project/create');
export const UPDATE_PROJECT = resolveEndpoint('project/update');
export const DELETE_PROJECT = resolveEndpoint('project/delete');
export const LIST_ADD_PROJECT = resolveEndpoint('add_project/list');
export const GET_ADD_PROJECT = resolveEndpoint('add_project/get');
export const DELETE_ADD_PROJECT = resolveEndpoint('add_project/delete');
export const CREATE_ADD_PROJECT = resolveEndpoint('add_project/create');
export const UPDATE_ADD_PROJECT = resolveEndpoint('add_project/update');

// TOD0
export const TODOCREATE = resolveEndpoint('todo/create');
export const TODO_UPDATE = resolveEndpoint('todo/update/');
export const TODO_LIST = resolveEndpoint('todo/list');
export const TODO_DELETE = resolveEndpoint('todo/delete/');
export const PROJECT_TODOLIST = resolveEndpoint('todo/list_project');
export const TASK_BULK_UPLOAD = resolveEndpoint('todo/bulk-upload');

// Tod0 Category
export const CREATECATEGORY = resolveEndpoint('todo_category/create');
export const LISTCATEGORY = resolveEndpoint('todo_category/list');
export const CATEGORY_DELETE = resolveEndpoint('todo_category/delete/');

// Timesheets
export const PROJECT_TODO_EMPLOYEE_LIST = resolveEndpoint('timesheets/list');
export const BUDGET_LIST = resolveEndpoint('timesheets/list_budget?project_id=');

// Employee Device
export const LIST_EMPLOYEEDEVICE = resolveEndpoint('employee_device/list');
export const LIST_ADMINS_EMPLOYEEDEVICE = resolveEndpoint('employee_device/list_admin');
export const DELETE_EMPLOYEEDEVICE = resolveEndpoint('employee_device/delete/');
export const ADDDEVICE = resolveEndpoint('employee_device/create');
export const UPDATEDEVICE = resolveEndpoint('employee_device/update/');
export const PENDING_DEVICE_LIST = resolveEndpoint('employee_device/list_pending_dev');
export const PENDING_DEVICE_EMPLOYEE_LIST = resolveEndpoint('employee_device/list_employee_by_device');
export const DELETE_PENDING_DEVICE = resolveEndpoint('employee_device/delete_Pending_device/');
export const DELDEVICE = resolveEndpoint('api/del_device');
export const DELSCREEN = resolveEndpoint('api/del_screen');

// Project Discussion
export const MESSAGE_CREATE = resolveEndpoint('project_discussion/create');
export const MESSAGE_LIST = resolveEndpoint('project_discussion/list');

// Timeoff
export const LISTTIMEOFF = resolveEndpoint('timeoff/list');
export const CREATETIMEOFF = resolveEndpoint('timeoff/create');

// Subscription
export const LISTSUBSCRIPTION = resolveEndpoint('api/subscriptions');
export const ADDSUBSCRIPTIONPLAN = resolveEndpoint('api/subscriptions/create');
export const DELETESUBSCRIPTIONPLAN = resolveEndpoint('api/subscriptions/delete/');
export const EDITSUBSCRIPTIONPLAN = resolveEndpoint('api/subscriptions/update/');

// Scheduling
export const LISTSCHEDULE = resolveEndpoint('scheduling/list');
export const UPDATE_SCHEDULE = resolveEndpoint('scheduling/update/');
export const DELETE_SCHEDULE = resolveEndpoint('scheduling/delete/');
export const CREATE_SCHEDULE = resolveEndpoint('scheduling/create');

// Employee Scheduling
export const LIST_EMPLOYEE_SCHEDULE = resolveEndpoint('employee_scheduling/list_employee_scheduling');
export const EMPLOYEESCHEDULING = resolveEndpoint('employee_scheduling/list');
export const CREATEEMPLOYEESCHEDULE = resolveEndpoint('employee_scheduling/create');
export const DELETE_EMPLOYEE_SCHEDULE = resolveEndpoint('employee_scheduling/delete/');
export const UPDATE_EMPLOYEE_SCHEDULE = resolveEndpoint('employee_scheduling/update/');

// License
export const CHECK_LICENSE = resolveEndpoint('customer/check_license');
export const GET_LICENSE_DATA = resolveEndpoint('license_app/get_license_data');
export const SEND_VERIFICATION_CODE = resolveEndpoint('license_app/send_verification_code');
export const VERIFY_EMAIL_CODE = resolveEndpoint('license_app/verify_email_code');
export const UPDATE_LICENSE = resolveEndpoint('license_app/update_license');

// Calendar
export const LIST_CALENDAR = resolveEndpoint('events/list');
export const ADD_CALENDAR = resolveEndpoint('events/create');
export const UPDATE_CALENDAR = resolveEndpoint('events/update/');

// Category
export const CREATE_CATEGORY = resolveEndpoint('api/categories/add');
export const UPDATE_CATEGORY = resolveEndpoint('api/category/update/');
export const LIST_CATEGORY = resolveEndpoint('api/categories');
export const DELETE_CATEGORY = resolveEndpoint('api/category/delete/');

// Subcategory
export const CREATE_SUBCATEGORY = resolveEndpoint('api/subcategories/add');
export const LIST_SUBCATEGORY = resolveEndpoint('api/subcategories?category_id=');
export const UPDATE_SUBCATEGORY = resolveEndpoint('api/subcategories/update/');
export const DELETE_SUBCATEGORY = resolveEndpoint('api/subcategories/delete/');

// Knowledge Transfer
export const KT_LIST = resolveEndpoint('api/knowledge-transfers');
export const ADD_KT = resolveEndpoint('api/knowledge-transfers/add');
export const DELETE_KT = resolveEndpoint('api/delete_kt/');
export const UPDATE_KT = resolveEndpoint('api/update_kt/');
export const KT_DETAIL = resolveEndpoint('api/list_kt_id/');
export const ADD_KT_DETAILS = resolveEndpoint('api/kt-details/add');
export const KT_VIEW_UPDATE = resolveEndpoint('/api/view-update');

// Task
export const LIST_TASKASSIGN = resolveEndpoint('api/list-task-assign/');
export const UPDATE_RATING = resolveEndpoint('api/rating-update');

// Admin
export const SUB_ADMIN = resolveEndpoint('api/subtransactions_add');
export const VALID_SUB_ADMIN = resolveEndpoint('api/subtransactions/');

// File Upload
export const UPLOADKAFAA = resolveEndpoint('api/kafaa_upload');

// Tracking
export const CREATE_TRACK = resolveEndpoint('api/task_tracking/create');
export const LIST_TRACK = resolveEndpoint('api/list_task_timer');
export const LIST_TASK_PROJECT = resolveEndpoint('api/list_project_timer?project_id=');
export const LIST_URL_TRACK = resolveEndpoint('api/list_url_task_timer');
export const FILTER_URL_TRACK = resolveEndpoint('api/filter_url_task_timer');
export const MANUAL_TIME_ADD = resolveEndpoint('api/manual_time/add');

// Budget
export const CREATE_BUDGET = resolveEndpoint('project/create_project_budget');
export const LIST_BUDGET = resolveEndpoint('project/list_budget/');
export const DELETE_BUDGET = resolveEndpoint('project/delete_budget');

// Transactions
export const CREATE_TRANSACTION = resolveEndpoint('project/transactions/create');
export const LIST_TRANSACTION = resolveEndpoint('project/transactions/list');
export const UPDATE_TRANSACTION = resolveEndpoint('project/transactions/update/');
export const DELETE_TRANSACTION = resolveEndpoint('project/transactions/delete/');

// Expenses
export const CREATE_EXPENSES = resolveEndpoint('api/create/expenses');
export const UPDATE_EXPENSES = resolveEndpoint('api/update/expenses/');
export const DELETE_EXPENSES = resolveEndpoint('api/delete/expenses/');

// Client Validation
export const CHECK_VALID = MONGOAPI_BASE_URL + 'client/valid';
export const VALID_CLIENT_LOGIN = MONGOAPI_BASE_URL + 'client/valid';
export const NEW_CLIENT_LOGIN = MONGOAPI_BASE_URL + 'client/login';

// Task Report
export const TASK_REPORT_API = resolveEndpoint('api/task_report');

// Kafaa Offline Sync APIs
export const KAFAA_LIST = resolveEndpoint('employee/kafaa_list/');
export const KAFAA_UPLOAD = APIBASE_URL + 'employee/upload/';
export const KAFAA_ACTIVITY = APIBASE_URL + 'employee/activity/';
export const KAFAA_HEARTBEAT = APIBASE_URL + 'employee/heartbeat/';